import React from 'react';

export default function Application() {
  return (
    <div className="mt-6 lg:mt-16 flex flex-col max-w-3xl mx-auto p-4 lg:p-12">
      <div className="mx-auto flex flex-col mt-20">
        <div className="w-20 h-2 bg-cyan ml-[25px] lg:ml-[100px]" />
        <h2 className="font-bold text-3xl lg:text-5xl text-neutral-600 text-center">
          Carreras Scholarship Application
        </h2>
        <p className="text-base lg:text-lg text-neutral-500 text-center mt-4">
          This scholarship is available to students pursuing studies at numerous
          tertiary-level institutions across Jamaica and are in need of
          financial assistance. They must be Jamaican citizens who are 18 years
          and older and have an exemplary academic record.
        </p>
      </div>
      <div className="mx-auto flex flex-col mt-9">
        <p className="font-bold text-xl lg:text-2xl text-neutral-600 text-center uppercase">
          APPLICATION DEADLINE: JULY 1, 2026 AT 6:00.P.M
        </p>
        <p className="font-bold text-base lg:text-lg text-neutral-500 text-center uppercase mt-4">
          ALL SUCCESSFUL APPLICANTS WILL BE CONTACTED
          <br />
          ON OR BEFORE JULY 31, 2026
        </p>
      </div>
    </div>
  );
}
